import { Fragment } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { Layout } from '../components/layout/Layout'
import { routes } from './routes'
import useHasPermiso from '../hooks/autenticacion/useHasPermiso'
import AjustesPagina from '../pages/ajustes/AjustesPagina'

const PrivateRoutes = () => {
  const { hasPermiso } = useHasPermiso()

  /**
   * Registra solo rutas permitidas para el usuario actual.
   *
   * `inicio` y `notificaciones` son rutas privadas por sesion, pero no declaran
   * rol especifico. Las rutas hijas se publican cuando la ruta padre cumple sus
   * permisos.
   */
  return (
    <Routes>
      <Route element={<Layout />}>
        {/* Paginas */}
        <Route path='iniciar-sesion/*' element={<Navigate to='/inicio' />} />
        <Route path='/ajustes' element={<AjustesPagina />} />
        {routes.map(({ path, Componente, children, permisos }) => {
          if (hasPermiso(permisos) || path === 'inicio' || path === 'notificaciones') {
            return (
              <Fragment key={path}>
                <Route path={path} element={<Componente />} />
                {children?.map((props) => (
                  <Route key={props.path} path={props.path} element={<props.Componente />} />
                ))}
              </Fragment>
            )
          } else {
            return <Fragment key={path}></Fragment>
          }
        })}
        {/* En caso de no encontrar la pagina */}
        <Route path='*' element={<Navigate to={'inicio'} replace />} />
      </Route>
    </Routes>
  )
}

export { PrivateRoutes }
